import { useQuery } from 'react-query';
import request from '../../../../helpers/request';
import { getQueryTransportKeys } from '../getQueryTransportKeys';

const getTransportAttachments = async (transportId) => {
  return await request.get(
    `/HousingStock/transport_attachments/${transportId}`,
    {},
    'При загрузке вложений произошла ошибка',
    []
  );
};

const useTransportAttachments = (transportId, options = {}) => {
  return useQuery(
    getQueryTransportKeys.transportDocs(transportId),
    () => getTransportAttachments(transportId),
    options
  );
};

export default useTransportAttachments;
